export const URL_PARAMS = {
  SALES_GROUP_ID: 'salesGroupId',
  SALES_GROUP_FROM: 'salesGroupFrom',
  SALES_GROUP_TO: 'salesGroupTo',
  SOURCE_ID: 'sourceId'
} as const

export type UrlParams = keyof typeof URL_PARAMS
